export default "https://assets.egbcdn.net/assets/packs/_/videos/lootbox/video-csgo-129797dbbc80d126bdeea95aca6fc9f6.mp4";